import React, {Component} from 'react';
import config from '../../config';
import cookie from 'js-cookie';

import {getStyleValue} from '../Helpers/Helpers';

// Icons
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Cached from '@mui/icons-material/Cached';
import Refresh from '@mui/icons-material/Refresh';
import PowerSettingsNew from '@mui/icons-material/PowerSettingsNew';
import Language from '@mui/icons-material/Language';
import Today from '@mui/icons-material/Today';
import CloudDownload from '@mui/icons-material/CloudDownload';
import Done from '@mui/icons-material/Done';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import Wifi from '@mui/icons-material/Wifi';
import CloudOff from '@mui/icons-material/CloudOff';
import Clear from '@mui/icons-material/Clear';
import Send from '@mui/icons-material/Send';

import {
	CircularProgress,
	Divider,
	Snackbar,
	Menu,
	MenuItem,
	ListItemIcon,
	ListItemText,
	IconButton,
} from '@mui/material';

export const progressIndicator = (
	<CircularProgress
		size={30}
		style={{verticalAlign: 'middle', marginRight: getStyleValue('spacing-half')}}
		color="inherit"
	/>
);

class TopMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			snackbarOpen: false,
			snackbarStatus: '',
			fetching: false,
			anchorEl: null,
		};
	}
	closeMenu() {
		this.setState({ anchorEl: null })
	}
	componentDidMount() {
		this._mounted = true;
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.addEventListener('message', (e) => this.showSnackbar(e.data.message)); // bind to component instead of SW
		}
		window.addEventListener('online', this.handleOnlineEvent.bind(this));
		window.addEventListener('offline', this.handleOnlineEvent.bind(this));
	}
	componentWillUnmount() {
		this._mounted = false;
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.removeEventListener('message', (e) => this.showSnackbar(e.data.message)) // bind to component instead of SW
		}
		window.removeEventListener('online', this.handleOnlineEvent);
		window.removeEventListener('offline', this.handleOnlineEvent);
	}
	handleOnlineEvent(event) {
		if (this._mounted) {
			if (event.type === 'online') {
				this.showSnackbar(this.props.t.connection_reinstated);
			} else {
				this.showSnackbar(this.props.t.connection_dropped);
			}
		}
	}
	showSnackbar(message) {
		this.setState({
			snackbarOpen: true,
			snackbarStatus: message,
		});
	}

	logoff() {
		cookie.remove('auth')
		cookie.remove('username')
		cookie.remove('name')
		cookie.remove('all_fetched');
		if (!navigator.onLine) {
			this.props.clearAllState();
		} else {
			fetch(`${config.api.url}/logout`, {
				method: 'post',
				credentials: 'include'
			})
				.catch(err => console.error(err))
				.then(() => this.props.clearAllState()); // don’t care if server was ok or not, we’re still clearing all state and logging out the user as much we can
		}
	}

	openLog() {
		this.closeMenu();
		this.props.history.push('/log');
	}

	openExtranet() {
		this.closeMenu();
		window.open(config.api.remoteApi, '_blank').focus();
	}
	openOverview() {
		this.closeMenu();
		this.props.history.push('/');
	}
	reload() {
		this.closeMenu();
		setTimeout(() => {
			this.props.history.go(this.props.location.pathname);
		}, 500);
	}
	resetCache() {
		this.closeMenu();

		// Clear out translations
		localStorage.removeItem('t')
		// Clear out brands and types
		localStorage.removeItem('BrandsAndTypes')

		// Clear out SW cache
		const msgChan = new MessageChannel();
		if (navigator.serviceWorker && navigator.serviceWorker.controller) {
			navigator.serviceWorker.controller.postMessage('clean-all-cache', [msgChan.port2]);
			cookie.remove('all_fetched');
			setTimeout(() => {
				this.props.history.go(this.props.location.pathname);
			}, 500);
		} // @todo Should show user friendly message
	}
	sendOutbox() {
		this.closeMenu();
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.ready.then(reg => reg.sync.register('outbox'))
		}
	}
	fetchAllData() {
		this.closeMenu();

		if (this.state.fetching) {
			return;
		}

		const msgChan = new MessageChannel();

		let counter = 1;
		const fetchCount = 3;

		const message = <div>{progressIndicator} { this.props.t.offline_work_preparing } </div>
		this.showSnackbar(message)
		this.setState({
			fetching: true
		});

		msgChan.port1.onmessage = event => {
			const data = JSON.parse(event.data);
			if (data.message === 'cache-full-data') {
				if (data.error) {
					if (data.status === 401) {
						this.logoff();
					} else {
						this.displayFailMessage(this.props.t.offline_work_failed);
					}
				} else {
					const message = <div>{progressIndicator} { this.props.t.offline_work_week } {counter}/{fetchCount} { this.props.t.offline_work_caching } </div>;
					this.setState({
						snackbarStatus: message,
						snackbarOpen: true,
					});
					if (counter >= fetchCount) {
						this.setState({ fetching: false })
						this.displayDoneMessage(this.props.t.offline_work_success);
					} else {
						counter++;
					}
				}
			}
		};
		navigator.serviceWorker.controller.postMessage('cache-full-data', [msgChan.port2]);
	}
	fetchOverviews() {
		this.closeMenu();
		if (this.state.fetching) {
			return;
		}

		const msgChan = new MessageChannel();

		const message = <div>{progressIndicator} { this.props.t.refreshing_overview }</div>
		this.showSnackbar(message)
		this.setState({ fetching: true });

		msgChan.port1.onmessage = event => {
			const data = JSON.parse(event.data);
			if (data.message === 'refresh-overviews') {
				if (data.error) {
					this.displayFailMessage(this.props.t.refreshing_overview_failed);
				} else {
					window.location.reload();
				}
			}
		};
		navigator.serviceWorker.controller.postMessage('refresh-overviews', [msgChan.port2]);
	}
	displayDoneMessage(message) {
		const prettyMessage = (
			<div>
				<Done color="secondary" style={{verticalAlign: '-5px', marginRight: getStyleValue('spacing-half')}} />
				{message}
			</div>
		);

		this.showSnackbar(prettyMessage)
		this.updateTopNavTitle();
	}
	updateTopNavTitle() {
		const syncTime = (new Date()).toISOString()
		cookie.set('all_fetched', syncTime, { expires: 365, sameSite: 'Strict' });
		this.props.updateAppState({ all_fetched: syncTime });
	}
	displayFailMessage(message) {
		const errorIcon = (
			<ErrorOutline style={{verticalAlign: 'middle', marginRight: getStyleValue('spacing-half')}}
				color="secondary" />
		);

		const snackbarMessage = <div>{errorIcon} {message}</div>
		this.showSnackbar(snackbarMessage)
		this.setState({ fetching: false });
	}
	handleClick(event) {
		this.setState({ anchorEl: event.currentTarget });
	}
	handleClose() {
		this.closeMenu();
	}
	handleCloseSnackbar() {
		this.setState({ snackbarOpen: false })
	}
	render() {
		const { match, location, history, staticContext, updateAppState, clearAllState, ...filteredProps } = this.props; // eslint-disable-line no-unused-vars
		const downloadUnavailable = (!navigator.serviceWorker || !navigator.serviceWorker.controller || !navigator.onLine) || this.state.fetching
		const snackbarStyle = {
			width: '100%',
			maxWidth: 'none',
			bottom: 0,
			left: 0,
			transform: 'translateX(0)',
			borderRadius: '0px',
		}
		const { anchorEl } = this.state;
		return (
			<div>
				<IconButton
					aria-label="More"
					aria-owns='long-menu'
					aria-haspopup="true"
					onClick={this.handleClick.bind(this)}
					color="inherit"
					size="large">
					<MoreVertIcon />
				</IconButton>
				<Menu
					{...filteredProps}
					id="long-menu"
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={this.handleClose.bind(this)}
					PaperProps={{ style: { minWidth: '336px' }}}
				>
					<MenuItem disabled={!navigator.onLine}>
						<ListItemText primary={navigator.onLine ? this.props.t.user_online : this.props.t.user_offline} />
						<ListItemIcon color="inherit">
							{navigator.onLine ? <Wifi />  : <CloudOff />}
						</ListItemIcon>
					</MenuItem>

					<MenuItem>{ cookie.get('name') }</MenuItem>
					<Divider component="div" />

					<MenuItem
						onClick={this.openOverview.bind(this)}>
						<ListItemIcon>
							<Today color="inherit"/>
						</ListItemIcon>
						<ListItemText primary={this.props.t.top_menu_planned_inspection} />
					</MenuItem>

					<MenuItem
						onClick={this.openExtranet.bind(this)}
						disabled={!navigator.onLine}>
						<ListItemIcon>
							<Language color="inherit" />
						</ListItemIcon>
						<ListItemText primary={`${this.props.t.top_menu_open} ${config.app_extranet_name}`} />
					</MenuItem>

					<MenuItem
						onClick={this.reload.bind(this)}>
						<ListItemIcon>
							<Refresh color="inherit"/>
						</ListItemIcon>
						<ListItemText primary={this.props.t.page_reload} />
					</MenuItem>
					<Divider component="div" />

					<MenuItem
						onClick={this.fetchAllData.bind(this)}
						disabled={downloadUnavailable}>
						<ListItemIcon>
							<CloudDownload color="inherit" />
						</ListItemIcon>
						<ListItemText primary={this.props.t.top_menu_get_inspection} />
					</MenuItem>

					<MenuItem
						onClick={this.sendOutbox.bind(this)}
						disabled={!navigator.onLine || downloadUnavailable}>
						<ListItemIcon>
							<Send color="inherit" />
						</ListItemIcon>
						<ListItemText primary={this.props.t.top_menu_save_inspection} />
					</MenuItem>

					<MenuItem
						onClick={this.fetchOverviews.bind(this)}
						disabled={downloadUnavailable}>
						<ListItemIcon>
							<Cached color="inherit" />
						</ListItemIcon>
						<ListItemText primary={this.props.t.top_menu_refresh} />
					</MenuItem>

					<MenuItem
						onClick={this.resetCache.bind(this)}
						disabled={downloadUnavailable}>
						<ListItemIcon>
							<Clear color="inherit" />
						</ListItemIcon>
						<ListItemText primary={this.props.t.top_menu_empty_cache} />
					</MenuItem>
					<Divider component="div" />

					<MenuItem
						onClick={this.openLog.bind(this)}>
						<ListItemIcon>
							<ErrorOutline color="inherit" />
						</ListItemIcon>
						<ListItemText primary={this.props.t.top_menu_check_log} />
					</MenuItem>

					<MenuItem
						onClick={this.logoff.bind(this)}>
						<ListItemIcon>
							<PowerSettingsNew color="inherit"/>
						</ListItemIcon>
						<ListItemText  primary={this.props.t.top_menu_log_off} />
					</MenuItem>
				</Menu>

				<Snackbar
					open={this.state.snackbarOpen}
					autoHideDuration={5000}
					message={this.state.snackbarStatus}
					style={snackbarStyle}
					onClose={this.handleCloseSnackbar.bind(this)}
					ContentProps={{ style: snackbarStyle }}
				/>
			</div>
		);
	}
}

export default TopMenu

